export default function showConfirmationModal() {
    return window.confirm("Vous avez des modifications non enregistrées. Voulez-vous continuez?");
}